import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'comp_payout_limit_modal',
    templateUrl: './payout_limit_modal.html',
})
export class PayoutLimitModal implements OnInit {
    constructor() {}

    init: boolean;
    ngOnInit() {
        if (this.init) return;
        this.init = true;
    }
    Payout_Limit_Modal_Close() {
        $('#Payout_Limit_Modal').modal('hide');
    }
}
